import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDButton from "components/MDButton";

export default function DialogConfirmarEliminarMaterialCampanha({
  open,
  onClose,
  materialParaEliminar,
  confirmarEliminarMaterial,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Eliminar material
      </DialogTitle>

      <DialogContent>
        Tem a certeza que pretende eliminar o material{" "}
        <strong>{materialParaEliminar?.material || materialParaEliminar?.refmaterial || ""}</strong>
        ?
      </DialogContent>

      <DialogActions>
        <MDButton onClick={onClose} color="secondary">
          Cancelar
        </MDButton>

        <MDButton onClick={confirmarEliminarMaterial} color="error">
          Eliminar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
